import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DriverCurrentTier } from '../../../../types';

@Component({
  selector: 'lohi-driver-performance',
  templateUrl: './driver-performance.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverPerformanceComponent implements OnInit {
  public selectedDriver$ = new BehaviorSubject<DriverCurrentTier>(null);

  constructor() {}

  public onChartSelected(driverCurrentTier: DriverCurrentTier) {
    this.selectedDriver$.next(driverCurrentTier);
  }

  public ngOnInit(): void {}
}
